export const EMBED_DOMAIN_MAX_COUNT = 50;

// Mirrors the backend rule: expects an already normalized value
const EMBED_DOMAIN_REGEX =
  /^(https?:\/\/)?(\*\.)?([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)*[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(:[0-9]{1,5})?$/;

export function normalizeEmbedDomain(domain: string): string {
  return domain.trim().toLowerCase().replace(/\/+$/, "");
}

export function isValidEmbedDomain(domain: string): boolean {
  return EMBED_DOMAIN_REGEX.test(domain);
}
